import {get, post} from './fetch';


export const validateZip = (zip) => {
    return post('/api/zip/validate', {"zip" : zip}, false);
}

export const getMarkets = () => {
    return get(`/api/markets/list`, false);
}

export const checkIsTOSEnabled = () => {
    return get(`/api/tos/enabled`, false);
}